import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CouponsManagementTable from "../../components/CouponsManagement/CouponsManagementTable";
import CreateCoupons from "../../components/CouponsManagement/CreateCoupons";
import CustomersTable from "../../components/Customers/CustomersTable";
import CreateAdminUsers from "../../components/Customers/CreateAdminUsers";
import EditAdminUsers from "../../components/Customers/EditAdminUsers";




const EditCustomerPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Edit Customers" subtitle={"Customers"} subUrl={"customers"} />
                <EditAdminUsers />





            </MasterLayout>
        </>
    );
};

export default EditCustomerPage;
